module.exports = __webpack_public_path__ + "static/media/home_2023.1b3ee9d1.JPG";